import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StorageService } from './core/services/storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveModule } from './core/directives/module/directive/directive.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DeliveryLocationModalComponent } from './shared/components/add-edit-address-component/delivery-location-modal/delivery-location-modal.component';
import { ApiRequestService, GlobalErrorHandler, TokenInterceptor } from './shared';
import { NetworkInterceptor } from './shared/interceptor/network.interceptor';
import { ResponseInterceptor } from './shared/interceptor/response.interceptor';
import { AppData } from './shared/services/app-data.service';
import { DynamicLayoutViewModalComponent } from './shared/components/dynamic-layout-view-modal/dynamic-layout-view-modal.component';
import { AddonModelRepeatComponent } from './modules/modals/addon-model-repeat/addon-model-repeat.component';
import { AddonVariantComponent } from './modules/modals/addon-variant/addon-variant.component';
import { ConfirmationModalComponent } from './modules/modals/confirmation-modal/confirmation-modal.component';
import { TaxAndChargesModalComponent } from './shared/components/tax-and-charges-modal/tax-and-charges-modal.component';
import { ChangeAddressModalComponent } from './shared/components/add-edit-address-component/change-address-modal/change-address-modal.component';
import { AddAddressOnCartModalComponent } from './shared/components/add-edit-address-component/add-address-on-cart-modal/add-address-on-cart-modal.component';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { ScratchCardModalComponent } from './shared/components/scratch-card-modal/scratch-card-modal.component';
import { RatingModalComponent } from './modules/account/component/rating-modal/rating-modal.component';
import { ThankyouForRatingModalComponent } from './modules/account/component/thankyou-for-rating-modal/thankyou-for-rating-modal.component';
import { PaymentsModalComponent } from './shared/components/payments-modal/payments-modal.component';
import { CouponTermsAndConditionsComponent } from './modules/modals/coupon-terms-and-conditions/coupon-terms-and-conditions/coupon-terms-and-conditions.component';
import { OfferDetailsComponent } from './modules/modals/offer-details/offer-details.component';
import { MenuCategoriesComponent } from './modules/modals/menu-categories/menu-categories.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { Network } from '@ionic-native/network/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx'

// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { LottieModule   } from 'ngx-lottie';
import player from 'lottie-web';
import { UniqueDeviceID } from '@ionic-native/unique-device-id/ngx';
//import { CleverTap } from '@ionic-native/clevertap/ngx';
import { LoaderService } from './shared/services/loader.service';
// import { AngularFireModule } from 'angularfire2';git 
// import { AngularFirestoreModule } from 'angularfire2/firestore';
// import { Firebase } from '@ionic-native/firebase/ngx';
// import { Contacts } from '@ionic-native/contacts/ngx'
import { Diagnostic } from '@ionic-native/diagnostic/ngx'
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { PaymentModalComponent } from './shared/components/payment-modal/payment-modal.component';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { LottieSplashScreen } from '@ionic-native/lottie-splash-screen/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
// import { FirebaseAnalytics } from '@awesome-cordova-plugins/firebase-analytics/ngx';
import { FirebaseDynamicLinks } from "@awesome-cordova-plugins/firebase-dynamic-links/ngx";
import { MenuDescriptionComponent } from './modules/modals/menu-description/menu-description.component';
import { TopHeaderMobileModule } from './core/core-components/mobile-core-components/top-header-mobile/top-header-mobile.module';
import { customAnimation } from './core/constants/custom.animation';
import { OrderConfirmationModalComponent } from './modules/modals/order-confirmation-modal/order-confirmation-modal.component';
import { WebIntent } from '@ionic-native/web-intent/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { BottomNavBarComponent } from './modules/bottom-nav-bar/bottom-nav-bar.component';

import { NgxMaskModule } from "ngx-mask";
import { AddressSearchModalComponent } from './modules/account/component/add-edit-address/address-search-modal/address-search-modal.component';
import { AddEditAddressModalComponent } from './modules/account/component/add-edit-address/add-edit-address-modal/add-edit-address-modal.component';
import { AppAvailability } from "@awesome-cordova-plugins/app-availability/ngx";
import { NgOtpInputModule } from 'ng-otp-input';
import { Facebook } from '@ionic-native/facebook/ngx';

import { TooltipModalComponent } from './shared/components/tooltip-modal/tooltip-modal.component';
import { ToggleButtonComponent } from './shared/components/toggle-button/toggle-button.component';
import { DeliverySlotComponent } from './shared/components/delivery-slot/delivery-slot.component';
import { AllInOneSDK } from '@awesome-cordova-plugins/all-in-one-sdk/ngx'

const COMPONENTS = [
  DeliveryLocationModalComponent,
  DynamicLayoutViewModalComponent,
  AddonModelRepeatComponent,
  AddonVariantComponent,
  ConfirmationModalComponent,
  TaxAndChargesModalComponent,
  ChangeAddressModalComponent,
  AddAddressOnCartModalComponent,
  ScratchCardModalComponent,
  RatingModalComponent,
  ThankyouForRatingModalComponent,
  AddEditAddressModalComponent,
  PaymentsModalComponent,
  CouponTermsAndConditionsComponent,
  OfferDetailsComponent,
  MenuCategoriesComponent,
  PaymentModalComponent,
  MenuDescriptionComponent,
  BottomNavBarComponent,
  AddressSearchModalComponent,
  ToggleButtonComponent,
  TooltipModalComponent,
  DeliverySlotComponent
]

export class IonicGestureConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    const mc = new (<any>window).Hammer(element);

    for (const eventName in this.overrides) {
      if (eventName) {
        mc.get(eventName).set(this.overrides[eventName]);
      }
    }

    return mc;
  }
}

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    COMPONENTS
  ],
  entryComponents: [
    COMPONENTS
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    GooglePlaceModule,
    HammerModule,
    NgOtpInputModule,
    IonicModule,
    // OtpConfirmationModalModule,
    // TopHeaderMobileModule, // moved to home-mobile
    // AngularFireModule.initializeApp(environment.firebaseConfig),
    // AngularFirestoreModule,
    LottieModule.forRoot({ player: playerFactory }),
    IonicModule.forRoot({navAnimation: customAnimation}),
    // LottieCacheModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.mapApiKey
    }),
    NgxMaskModule.forRoot()
    // Clipboard
    // ScratchCardMobileInfoModule // moved to home-mobile
  ],
  providers: [
    Clipboard,
    StorageService,
    ApiRequestService,
    LoaderService,
    StatusBar,
    SplashScreen,
    LottieSplashScreen,
    AppData,
    Network,
    SocialSharing,
    Geolocation,
    InAppBrowser,
    UniqueDeviceID,
    // FCM,
    Device,
    // AndroidNotch,
    //CleverTap,
    // Firebase,
    // Contacts,
    Diagnostic,
    FirebaseX,
    AppVersion,
    LocationAccuracy,
    // FirebaseAnalytics,
    LocalNotifications,
    FirebaseDynamicLinks,
    WebIntent,
    Clipboard,
    Facebook,
    // AndroidPermissions,
    // Appsflyer,
    AppAvailability,
    AllInOneSDK,
    {
      provide: APP_INITIALIZER,
      useFactory: (ad: AppData) => () => { return ad.ngOnInit() },
      deps: [AppData],
      multi: true
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: IonicGestureConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
